export const reviewCategories = [
  { label: "Customer Service", value: "customer_service" },
  { label: "Knowledge & Skills", value: "knowledge" },
  { label: "Reliability & Attendance", value: "reliability" },
  { label: "Teamwork & Communication", value: "teamwork" },
  { label: "Food Safety & Cleanliness", value: "food" },
];
